import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BackendService } from '@wilson/base';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { SafetyCertificate } from '@wilson/interfaces';

@Injectable()
export class SafetyCertificateService extends BackendService<SafetyCertificate> {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'safety-certificates';
}
